module.exports = __webpack_public_path__ + "img/web1icon3.b2909571.png";